import React, { useState } from 'react';
import './products.css';
import { DataGrid } from '@material-ui/data-grid';
import { DeleteOutline } from '@material-ui/icons';
import { productRows } from '../../dummyData';
import { Link } from 'react-router-dom';

const ProductList = () => {
    const [data, setData] = useState(productRows);
    const handleDelete = (id) => {
        setData(data.filter((item) => item.id !== id));
    };
    const columns = [
        {field: 'íd', headerName: 'ID', width: 90},
        { field: 'name', headerName: 'Product', width: 200, renderCell:(params)=>{
            return(
                <div className="productListProduct">
                    <img className="productListImg"src={params.row.img} alt="" />
                    {params.row.name}
                </div>
            )
        } },
        { field: 'stock', headerName: 'Stock', width: 200,},
        { field: 'status', headerName: 'Status', width: 120, },
        { field: 'price', headerName: 'Price', width: 160, },
        { field: 'action', headerName: 'Action', width: 160,renderCell:(params)=>{
            return(
                <>
                    <Link to ={"/product/"+params.row.id}>
                        <button className="productListEdit">Edit</button>
                    </Link>
                    <DeleteOutline className="productListDelete" onClick={()=>handleDelete(params.row.id)}/>
                </>
            )
        } },
    ];
    
    return (
        <div className="productList">
             <DataGrid  rows={data} columns={columns} pageSize={9}  checkboxSelection disableSelectionOnClick/>
        </div>
    )
}
export default ProductList